import { HttpClient } from 'api/http-client';
import { GroupedTimelines, Timeline } from './types';

class TimelineAPIClient extends HttpClient {
  public async getTimelines(companyId: number): Promise<Timeline[]> {
    return this.get<Timeline[]>('/timeline', {
      params: {
        companyId,
      },
    });
  }

  public async getGroupByMonth(companyId: number): Promise<GroupedTimelines> {
    return this.get<GroupedTimelines>(
      `/timeline/timeline-v2?companyId=${companyId}&groupBy=MONTH`,
    );
  }
}

export const TimelineAPI = new TimelineAPIClient();
